import {Component, Input, OnInit} from '@angular/core';
import {IAppState} from '../../store/interfaces/IAppState';
import {NgRedux} from '@angular-redux/store';

@Component({
  selector: 'preview-summary-button',
  templateUrl: './preview-summary-button.component.html',
  styleUrls: ['./preview-summary-button.component.scss']
})
export class PreviewSummaryButtonComponent implements OnInit {
  @Input() messages;
  state: IAppState;
  available = false;

  constructor(private _ngRedux: NgRedux<IAppState>) {}

  ngOnInit() {
    this.updateFromState();
    this._ngRedux.subscribe(() => {
      this.updateFromState();
    });
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    this.available = (this.state.availableReservation != null);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/preview-summary-button/preview-summary-button.component.ts